import Auth from '@aws-amplify/auth'
import httpClient from '@/services/httpClient'

export default {
  async setupTOTP() {
    try {
      const user = await Auth.currentAuthenticatedUser()
      console.log(user)
      const secretKey = await Auth.setupTOTP(user)
      return secretKey
    } catch (error) {
      console.error('Erro ao configurar TOTP:', error)
      throw error
    }
  },

  async verifyTOTP(code) {
    try {
      const user = await Auth.currentAuthenticatedUser()
      await Auth.verifyTotpToken(user, code)
      await Auth.setPreferredMFA(user, 'TOTP')
      return true
    } catch (error) {
      console.error('Erro ao verificar código TOTP:', error)
      throw error
    }
  },

  async setupSMS(phoneNumber) {
    try {
      const user = await Auth.currentAuthenticatedUser()

      // Atualiza o número de telefone no perfil do usuário
      await Auth.updateUserAttributes(user, {
        phone_number: phoneNumber, // Ex: "+5511999998888"
      })

      // Define o tipo de MFA preferencial para SMS
      await Auth.setPreferredMFA(user, 'SMS')

      console.log('MFA por SMS configurado com sucesso.')
      return true
    } catch (error) {
      console.error('Erro ao configurar MFA por SMS:', error)
      throw error
    }
  },

  async verifySMS(code) {
    try {
      const user = await Auth.currentAuthenticatedUser()

      await Auth.verifyTotpToken(user, code)
      await Auth.setPreferredMFA(user, 'SMS')
      return true
    } catch (error) {
      console.error('Erro ao verificar código SMS:', error)
      throw error
    }
  },

  async mfaSetup(mfaData) {
    const { data } = await httpClient.put('user/mfa?action=setup', mfaData)
    return data
  },

  async mfaVerify(mfaData) {
    const { data } = await httpClient.put('user/mfa?action=verify', mfaData)
    return data
  },

  async mfaDisable() {
    const { data } = await httpClient.put('user/mfa?action=disable')
    return data
  },

  async phoneRequestCode(number) {
    const data = await httpClient.put('user/phone-request-code', {
      phone_number: number,
    })
    return data
  },

  async phoneRequestCodeDisable() {
    const data = await httpClient.put('user/phone-request-code?action=disable')
    return data
  },

  async verifySmsCode(code) {
    const data = await httpClient.put('user/phone-verify-code', {
      verification_code: code,
    })
    return data
  },
  async disableSms(code) {
    const data = await httpClient.put('user/phone-verify-code?action=disable', {
      verification_code: code,
    })
    return data
  },

  async mfaDisableByUserId(id) {
    const { data } = await httpClient.put(`user/mfa/${id}?action=disable`)
    return data
  },
}
